/**
 * @generated SignedSource<<572175e27b660b6d0b864a1a4f849f50>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type src_workManagementBoard_BoardWithWorkflowsData_queryFragment$data = {
  readonly " $fragmentSpreads": FragmentRefs<"board_workManagementBoard_queryFragment" | "issueCreateContext_businessIssueCreate_IssueCreateProvider">;
  readonly " $fragmentType": "src_workManagementBoard_BoardWithWorkflowsData_queryFragment";
};
export type src_workManagementBoard_BoardWithWorkflowsData_queryFragment$key = {
  readonly " $data"?: src_workManagementBoard_BoardWithWorkflowsData_queryFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"src_workManagementBoard_BoardWithWorkflowsData_queryFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "src_workManagementBoard_BoardWithWorkflowsData_queryFragment",
  "selections": [
    {
      "kind": "FragmentSpread",
      "name": "board_workManagementBoard_queryFragment"
    },
    {
      "kind": "FragmentSpread",
      "name": "issueCreateContext_businessIssueCreate_IssueCreateProvider"
    }
  ],
  "type": "Query"
};

(node as any).hash = "5dbe59e139b948dd346dac917ec44147";

export default node;
